import Hero       from './sections/Hero';
import Manifiesto from './sections/Manifiesto';
import Oficios    from './sections/Oficios';
import Contacto   from './sections/Contacto';
import Footer     from './sections/Footer';

export default function App() {
  return (
    <>
      <Hero />
      <Manifiesto />
      <Oficios />
      <Contacto />
      <Footer />
    </>
  );
}
